module.exports = __webpack_public_path__ + "static/img/6.f60f2f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/eng/6.png
// module id = Gr92
// module chunks = 0